import React from "react";
import "../styles/home.css";
import Navbar from "../components/Navbar";
import HeroSection from "../components/Teamhero";
import TeamSection from "../components/TeamSection";

const About = () => {
  return (
    <div className="home">
      <Navbar />
      <HeroSection />
      <TeamSection />
    </div>
  );
};

export default About;
